import moment from 'moment'

export const getLastSyncAtValue = (userLastSyncAt?: string): string | number => {
    if (userLastSyncAt) return userLastSyncAt

    const fromStorage = window.localStorage.getItem('lastSyncAt')
    if (fromStorage && fromStorage !== 'undefined') return fromStorage

    return 0
}

export const isSyncConnectionsStarted = (): boolean => {
    const value = window.localStorage.getItem('syncConnectionsStarted')
    return !!value && value !== 'undefined'
}

export const isHomeSyncInProgress = (
    workspaceInitialSync?: boolean,
    lastSyncAt?: string | number,
): boolean => (
    (!workspaceInitialSync && moment().isBefore(moment(lastSyncAt).add(20, 'minutes'))) ||
    isSyncConnectionsStarted()
)
